import { Alert } from "@tosize/ui";
import { Suspense, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { useErrorContext } from "../../../context/ErrorContext";
import { usePostDataContext } from "../../../context/PostDataContext";
import useFinishes from "../../../hooks/useFinishes";
import useShapes from "../../../hooks/useShapes";
import { BackButton } from "../../ui/BackButton";
import FinishesTab from "../Finishes/FinishesTab";
import { SHAPE_DIMENSIONS_STEP_IDENTIFIER } from "./ShapeDimensions";

export const FINISHES_STEP_IDENTIFIER = "finishes";

export function Finishes() {
	const { shape } = useShapes();
	const { finishes, isLoading } = useFinishes();
	const { setWorkpiece } = usePostDataContext();
	const { hasErrors } = useErrorContext();

	useEffect(() => {
		if (hasErrors && !finishes?.some((finish) => finish.mandatory)) {
			setWorkpiece((prev) => ({ ...prev, finishes: { side: {} } }));
		}
	}, [finishes, hasErrors, setWorkpiece]);

	return (
		<>
			{hasErrors ? (
				<Alert variant="warning">
					<BackButton identifier={SHAPE_DIMENSIONS_STEP_IDENTIFIER}>
						<FormattedMessage defaultMessage="Vul eerst de afmetingen correct in" />
					</BackButton>
				</Alert>
			) : isLoading || !shape ? (
				<Alert variant="info">
					<FormattedMessage defaultMessage="Afwerkingen worden geladen" />
				</Alert>
			) : (
				<>
					{finishes && finishes.length > 0 ? (
						<InnerFinishes />
					) : (
						<Alert variant="info">
							<FormattedMessage defaultMessage="Voor deze vorm zijn geen afwerkingen beschikbaar" />
						</Alert>
					)}
				</>
			)}
		</>
	);
}

function InnerFinishes() {
	const { shape } = useShapes();
	const { finishes } = useFinishes();
	const { setWorkpiece } = usePostDataContext();
	const { hasErrors } = useErrorContext();

	useEffect(() => {
		if (hasErrors && !finishes?.some((finish) => finish.mandatory)) {
			setWorkpiece((prev) => ({ ...prev, finishes: { side: {} } }));
		}
	}, [finishes, hasErrors, setWorkpiece]);

	if (!(shape && finishes)) {
		return null;
	}

	return (
		<Suspense
			fallback={
				<Alert variant="info">
					<FormattedMessage defaultMessage="Afwerkingen worden geladen" />
				</Alert>
			}
		>
			<FinishesTab finishes={finishes} />
		</Suspense>
	);
}
